<script>
import { Modal, theme } from 'ant-design-vue';

export default {
  emits: ['onSubmit', 'onClose'],
  components: { Modal },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    submitText: {
      type: String,
      default: '',
    },
    submitBtnProps: {
      type: Object,
      default: () => ({}),
    },
    cancelText: {
      type: String,
      default: '',
    },
    cancelButtonProps: {
      type: Object,
      default: () => ({}),
    },
    width: {
      type: String,
      default: '35rem',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    enableFooter: {
      type: Boolean,
      default: false,
    },
    allowCloseOnBlur: {
      type: Boolean,
      default: false,
    },
    headerStyle: {
      type: Object,
      default: () => ({}),
    },
    hideCloseIcon: {
      type: Boolean,
      default: false,
    },
    centered: {
      type: Boolean,
      default: false,
    },
    bodyStyle: {
      type: Object,
      default: () => ({
        borderBottom: `0.063rem solid rgba(255,255,255,0.3)`,
        paddingBottom: '1.5rem',
      }),
    },
  },
  setup() {
    const { useToken } = theme;
    const { token } = useToken();

    return {
      token,
    };
  },
};
</script>

<template>
  <div>
    <!-- TODO: border color needs to be fetch from token once all the components are migrated to theme -->
    <Modal
      :open="show"
      @cancel="() => $emit('onClose', false)"
      @ok="() => $emit('onSubmit')"
      :okText="submitText"
      :okButtonProps="submitBtnProps"
      :cancelText="cancelText"
      :cancelButtonProps="cancelButtonProps"
      :width="width"
      :style="{ textAlign: 'left', top: '50px' }"
      :bodyStyle="bodyStyle"
      :confirm-loading="loading"
      :maskClosable="allowCloseOnBlur"
      :closable="!hideCloseIcon"
      :centered="centered"
    >
      <template #title>
        <div
          class="rex-modal-header-box"
          :style="{ borderColor: 'rgba(255,255,255,0.3)', ...headerStyle }"
        >
          <slot name="header" v-if="!title">
            <div>Title</div>
          </slot>
          <div v-else>
            {{ title }}
          </div>
        </div>
      </template>
      <slot name="body">
        <div>Body</div>
      </slot>
      <template #footer v-if="enableFooter">
        <slot name="footer">
          <div>footer</div>
        </slot>
      </template>
    </Modal>
  </div>
</template>

<style lang="scss" scoped>
.rex-modal-header-box {
  border-bottom: 0.063rem solid;
  padding-bottom: 0.75rem;
}
</style>
